import type { PersonalFormType } from '../types/defs';

export interface FormModelsState {
  formData: PersonalFormType;
  payData: Record<string, unknown>;
}

export const initFormModelsState = {
  formData: {},
  payData: null,
};

export default {
  namespace: 'formModels',
  state: initFormModelsState,

  /* 更新状态（通用） */
  reducers: {
    update: (state: FormModelsState, payload: Partial<FormModelsState>) => ({
      ...state,
      ...payload,
    }),
    init: () => initFormModelsState,
  },
};
